import { render, staticRenderFns } from "./folders-modal-edit-name.vue?vue&type=template&id=9fe552c8&scoped=true"
import script from "./folders-modal-edit-name.vue?vue&type=script&lang=js"
export * from "./folders-modal-edit-name.vue?vue&type=script&lang=js"
import style0 from "./folders-modal-edit-name.vue?vue&type=style&index=0&id=9fe552c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe552c8",
  null
  
)

export default component.exports